<script setup lang="ts">
import type { FormElement } from './types';
import { FormElementsConfigMap } from './constants';
import { useFormEditStore } from './formEditStore';

const { t } = useI18n();

const store = useFormEditStore();
const { editedElement } = storeToRefs(store);

const elementsMap = computed(() => {
    return FormElementsConfigMap;
});

const handleUpdate = (el: FormElement) => {
    store.applyElementEdit(el);
};
</script>
<template>
    <div class="flex flex-col h-full">
        <h3 class="font-light py-4">
            {{ t('formBuilder.elementDetails') }} {{ editedElement ? ': ' + t(elementsMap[editedElement.type]!.elementLabel) : '' }}
        </h3>


        <component
            :is="elementsMap[editedElement.type]!.propertiesEditorComponent"
            v-if="editedElement"
            :element="editedElement"
            @update:model-value="handleUpdate"
        />

        <h4 v-else class="font-light py-4">
            {{ t('formBuilder.selectElement') }}
        </h4>
    </div>
</template>

